import { ProductInterface } from '../Model/Product';
import { AbstractFilter } from './AbstractFilter';
import { EqualsFilterValueType } from './EqualsFilter';
import { FilterInterface } from './FilterInterface';

/**
 * This Filter resolves to TRUE if the Product, it's parent or at least one of the children contains an Attribute
 * for `keyPath` which matches `value`
 */
export class ContainsFilter<T extends EqualsFilterValueType> extends AbstractFilter<T> {
    public matches(product: ProductInterface): boolean {
        const keyPath = this.keyPath;
        const value = this.value;
        if (this.productMatches(product, keyPath, value)) {
            return true;
        }

        const attributes = this.resolveAttributes(product, keyPath);

        return undefined !== attributes.find(attribute => this.matchAttribute(attribute, value));
    }

    protected clone(): FilterInterface<T> {
        return new ContainsFilter(this.keyPath, this.value, this.type, this.isActive);
    }
}
